var styles = {
  "Token": "Online-Store-UI-Token_1ry3p",
  "invalid": "Online-Store-UI-Token--invalid_99qbq",
  "warning": "Online-Store-UI-Token--warning_vaa73",
  "highlight": "Online-Store-UI-Token--highlight_1ek4b",
  "loading": "Online-Store-UI-Token--loading_vakiz",
  "selected": "Online-Store-UI-Token--selected_1t1b8",
  "block": "Online-Store-UI-Token--block_1s06c",
  "Label": "Online-Store-UI-Token__Label_1rwrr",
  "Icon": "Online-Store-UI-Token__Icon_w2llr",
  "right": "Online-Store-UI-Token--right_1sdbd"
};

export { styles as default };
